import { ESTOQUE_BACKEND_URL } from "../settings";
import { api } from "./api";

class PrinterService {
  constructor() {
    this.url = ESTOQUE_BACKEND_URL;
  }

  async getPrinters() {
    const url = `${this.url}/api/blueberry/v1/printer/`;
    return await api.get(url);
  }
}

const printerService = new PrinterService();
export default printerService;
